import * as Yup from 'yup'

const ProfileSchema = Yup.object().shape( {
    tipo_inst_edu: Yup.string()
        .required('Requerido'),
    nivel: Yup.string()
        .required('Requerido'),
    region: Yup.string()
        .required('Requerido.'),
    provincia: Yup.string()
        .required('Requerido'),
    distrito: Yup.string()
        .required('Requerido'),
    inst_educativa: Yup.string()
        .required('Requerido'),
    tipo_doc_hijo: Yup.string()
        .required('Requerido'),
    nacionalidad: Yup.string()
        .required('Requerido'),
    dni: Yup.string()
        .when("tipo_doc_hijo", {
            is: (tipo_doc_hijo => {
                return ( tipo_doc_hijo === '0101' ) ? true : false;
                }),
            then: Yup.string().required('Requerido')
                    .min(8, 'Debe tener 8 dígitos')
                    .max(8, 'Debe tener 8 dígitos'),
        })
        .when("tipo_doc_hijo", {
            is: (tipo_doc_hijo => {
                return ( tipo_doc_hijo === '0102' || tipo_doc_hijo === '0103' ) ? true : false;
                }),
            then: Yup.string().required('Requerido')
                    .min(12, 'Debe tener 12 caracteres')
                    .max(12, 'Debe tener 12 caracteres'),
        }),
    nombre: Yup.string()
        .required('Requerido')
        .trim('Requerido'),
    profesor: Yup.string()
    .required('Requerido.')
    .trim('Requerido'),
    apellido_paterno: Yup.string()
        .required('Requerido.')
        .trim('Requerido'),
    apellido_materno: Yup.string()
        .required('Requerido')
        .trim('Requerido'),
    genero: Yup.string()
        .required('Requerido'),
    autorizacion: Yup.string()
        .required('Requerido'),
    email: Yup.string().email('Correo inválido'),
    grado: Yup.string()
        .required('Requerido'),
        // .nullable(),
    seccion: Yup.string()
        .required('Requerido'),
    // acceptTerms: Yup.bool().oneOf([true], 'Debe seleccionar el formato'),
    // formato: Yup.array()
    //     .required("Debe seleccionar el formato"),
    formato: Yup.string()
        .required("Debe seleccionar formato"),
    // municipalidad: Yup.string()
    //     .required('Requerido')



    
    // region_muni: Yup.string().required('Requerido'),
    // provincia_muni: Yup.string().required('Requerido'),
    // distrito_muni: Yup.string().required('Requerido'),
    // referencia_muni: Yup.string().required('Requerido'),


    // region_muni: Yup.string()
    //     .when("formato", {
    //         is: ( formato => {
    //             return formato === '72' || formato === '74' || formato === '76';
    //             } ),
    //         then: Yup.string().required('Requerido')
    //     }),
    // provincia_muni: Yup.string()
    //     .when("formato", {
    //         is: ( formato => {
    //             return formato === '72' || formato === '74' || formato === '76';
    //             } ),
    //         then: Yup.string().required('Requerido')
    //     }),
    // distrito_muni: Yup.string()
    //     .when("formato", {
    //         is: ( formato => {
    //             return formato === '72' || formato === '74' || formato === '76';
    //             } ),
    //         then: Yup.string().required('Requerido')
    //     }),
    // referencia_muni: Yup.string()
    //     .when("formato", {
    //         is: ( formato => {
    //             return formato === '74' || formato === '76';
    //             } ),
    //         then: Yup.string().required('Requerido')
    //     }),
    municipalidad: Yup.string()
        // .when("formato", {
        //     is: ( formato => {
        //         return formato === '72';
        //         } ),
        //     then: 
        //         Yup.string()
        //         .when("existe_observacion", {
        //             is: ( existe_observacion => {
        //                 return !existe_observacion;
        //                 } ),
        //             then: Yup.string().required('Requerido')
        //         })
        // })
        .when("formato", {
            is: ( formato => {
                return formato === '95';
                } ),
            then: Yup.string().required('Requerido')
        }),









    // aceptar_termino: Yup.boolean()
    // .oneOf([true]),
    // riesgos: Yup.array( Yup.string().oneOf( ['High', 'Medium', 'Low'] ) ).min(1),
    // comentario_riesgos: Yup.mixed().when('riesgos', {
    //     is: ( riesgos ) => riesgos.find( ir => ir === 'High'),
    //     then: Yup.string().required().min(20).max(100),
    //     otherwise: Yup.string().min(20).max(100)
    // })
} )

// const schema = yup
//   .object({
//     red: yup.boolean(),
//     orange: yup.boolean(),
//     green: yup.boolean()
//   })
//   .test(
//     'myCustomTest',
//     null,
//     (obj) => {
//       if ( obj.red || obj.orange || obj.green ) {
//         return true; // everything is fine
//       }

//       return new yup.ValidationError(
//         'Please check one checkbox',
//         null,
//         'myCustomFieldName'
//       );
//     }
//   );

export default ProfileSchema